import { SITE_SURVEY_TEMPLATES_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/site_survey_templates_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'siteSurveyTemplatesIndex',
	'woTasksCollection',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
